import { FacebookEventName } from './event-name.type';
import { FacebookMatchKeyObj } from './match-keys.type';
import * as ss from 'superstruct';

export const FacebookOfflineEvent = ss.type({
  event_time: ss.number(),
  event_name: FacebookEventName,
  currency: ss.optional(ss.string()), // Required for event_type == "Purchase".
  value: ss.optional(ss.number()), // Required for event_type == "Purchase".
  content_type: ss.optional(ss.string()),
  custom_data: ss.optional(ss.record(ss.string(), ss.unknown())),
  order_id: ss.optional(ss.string()),
  match_keys: ss.optional(FacebookMatchKeyObj),
  direct_attribution: ss.optional(ss.boolean()), // Marketing Milk Specific
  // Ignore contents.
});

export type FacebookOfflineEvent = ss.Infer<typeof FacebookOfflineEvent>;

export const fakeFbOfflineEvent: () => FacebookOfflineEvent = () => ({
  event_time: new Date().valueOf(),
  event_name: 'AddPaymentInfo',
  currency: 'USD',
  value: 12.03,
  order_id: '5',
  match_keys: {
    email: ['foo@example.com'],
    fn: 'John',
    ln: 'Doe',
  },
});
